<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div *ngIf="this.isInnerHTML == null && this.label != null" class="col-md-12">
      <div  class="form-label mb-1" >
        {{this.label}}
        <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
        <span *ngIf="this.tooltip != null" class="mt-1">
          <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
        </span> 
      </div> 
    </div>

    <div *ngIf="this.isInnerHTML == 'Y' && this.label != null" class="col-md-12">
      <div  class="form-label mb-1"  [innerHTML]="this.label"></div> 
    </div>

    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>
  <div class="row">       
    <div class="col">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label class="btn btn-secondary btn-large-width" tabindex="0"  [ngClass]="{ active: this.formGroup.get(this.propertyName)?.value === this.values[0]}">
          <input type="radio" name="{{this.propertyId}}_option1" id="{{this.propertyId}}_option1" autocomplete="off" (click)="userAction(this.values[0])">{{this.display[0]}}</label>
        <label class="btn btn-secondary btn-large-width" tabindex="1"  [ngClass]="{ active: this.formGroup.get(this.propertyName)?.value === this.values[1]}">
          <input type="radio" name="{{this.propertyId}}_option2" id="{{this.propertyId}}_option2" autocomplete="off" (click)="userAction(this.values[1])">{{this.display[1]}}</label>
      </div>
    </div>      
  </div>
 
</div>